// A row's standing at a glance: a ring filling with ticks, a pulsing dot
// while building, a ribbon when finished; and the little bars under a count.
import type { CSSProperties } from 'react';
import { Icon } from './Icon';

export type GlyphStanding = 'ring' | 'building' | 'finished';

export interface StandingGlyphProps {
  standing: GlyphStanding;
  /** 0 to 1 of the ring filled. */
  fraction?: number;
}

export function StandingGlyph({ standing, fraction = 0 }: StandingGlyphProps) {
  if (standing === 'finished') return <span className="glyph-done"><Icon name="ribbon" /></span>;
  if (standing === 'building') return <span className="glyph-building" />;
  return <span className="ring" style={{ '--p': Math.round(Math.min(1, Math.max(0, fraction)) * 100) } as CSSProperties} />;
}

/** One bar per step, the done ones in honey and the next one taller; capped at twelve. */
export function Ticks({ done, total }: { done: number; total: number }) {
  const n = Math.min(total, 12);
  return (
    <span className="ticks" aria-hidden="true">
      {Array.from({ length: n }, (_, i) => <i key={i} className={i < done ? 'on' : i === done ? 'next' : undefined} />)}
    </span>
  );
}
